'use strict';

var interval;
var containerImage = '.showcase-item-image.porn-hover';
var imagesSelector = '.showcase-image';
var bulletsSelector = '.showcase-item-bullets';

var Porn = {
  rotateImage: function ($wrapper) {
    var images = $wrapper.data('images');
    var index = $wrapper.data('index') || 1;

    if ((images || []).length <= 1) return;

    if (index === images.length) {
      index = 0;
    }

    Porn.goTo($wrapper, index);

    index++;
    $wrapper.data('index', index);
  },

  goTo: function ($wrapper, index) {
    var images = $wrapper.data('images');
    var $bullets = $wrapper.find(bulletsSelector);
    var $activeBullet = $bullets.find('.is-active');

    $activeBullet.removeClass('is-active');
    $bullets.find('i').eq(index).addClass('is-active');
    $wrapper.find(imagesSelector).attr('src', images[index]);
    $wrapper.find(imagesSelector).attr('srcset', Porn.srcset(images[index]));
  },

  mouseleave: function () {
    clearInterval(interval);
  },

  srcset: function (src) {
    return (src || '').replace('/v1/imagens', '/dpr_2.0/v1/imagens');
  },

  mouseenter: function () {
    var $wrapper = $(this).closest('.showcase-item');
    Porn.rotateImage($wrapper);
    interval = setInterval(function () {
      Porn.rotateImage($wrapper);
    }, 1000);
  },

  click: function (event) {
    event.stopPropagation();
  },

  bulletHover: function () {
    var $wrapper = $(this).closest('.showcase-item');
    var index = $(this).data('index') || 1;
    Porn.goTo($wrapper, index);
    $wrapper.data('index', index + 1);
  }
};

if (blz.globals.platform === 'desktop') {
  $('body')
    .on('mouseenter', containerImage, Porn.mouseenter)
    .on('mouseleave', containerImage, Porn.mouseleave)
    .on('click', containerImage, Porn.click)
    .on('mouseover', bulletsSelector + ' i', Porn.bulletHover);
}
